const EventType = Object.freeze({
  custom: 'EventType_Custom',
  message: 'EventType_Message',
  promotion: 'EventType_Promotion'
})

export { EventType }



// WEBPACK FOOTER //
// ./src/common/enum/EventType.js